import { TblSortDir } from '../table.types';

export function sortBooleanAsStringFn(col: string, dir: TblSortDir): (a: any, b: any) => number {
    return (a, b): number => {
        const toString = (val: any): string => {
            if (typeof val === 'boolean') return val ? 'YES' : 'NO';
            if (val === undefined || val === null) return 'ZZZ'; // Sort undefined/null last
            return `${val}`;
        };
        const aVal = toString(a[col]);
        const bVal = toString(b[col]);
        return dir === 'DSC' ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
    };
}
